export const getEmptyListPlaceholder = (
  canCreate: boolean,
  message = '',
  hint = 'Press Plus button to create a new one.'
): string => (canCreate ? `${message} ${hint}` : message);
